require('../app.js')

Vue.component('clock-component', require('../components/Clock.vue').default)
Vue.component('search-bar', require('../components/SearchBar.vue').default)
Vue.component('show-more', require('../components/ShowMore.vue').default)
Vue.component('tabs', require('../components/Tabs.vue').default)
Vue.component('tab', require('../components/Tab.vue').default)
Vue.component('home-news', require('../components/HomeNews.vue').default)

Vue.component('home', require('./Home.vue').default)
